import { useContext } from "react";
import { LocationContext } from "@/context/LocationContext";

export function useIsLocationAllowed() {
    if (!LocationContext) {
      throw new Error('useIsLocationAllowed must be used within a LocationProvider');
    }
    
    const context = useContext(LocationContext);
    if (context === undefined) {
      throw new Error('useLocation must be used within a LocationProvider');
    }
    return [context.locationAllowed, context.isLocationLoading, context.error, context.refreshLocation, context.setLocation] as const;
  }